import { render, staticRenderFns } from "./tagsPageOpened.vue?vue&type=template&id=75df5d9a&"
import script from "./tagsPageOpened.vue?vue&type=script&lang=js&"
export * from "./tagsPageOpened.vue?vue&type=script&lang=js&"
import style0 from "./tagsPageOpened.vue?vue&type=style&index=0&id=75df5d9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports